module.exports = __webpack_public_path__ + "img/yellow-truck.8a3a08cd.png";